import * as React from "react";
import {useTheme} from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import PrintIcon from "@mui/icons-material/Print";
import {
  Alert,
  Card,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Snackbar,
  Tooltip
} from "@mui/material";
import MDButton from "components/MDButton";
import dayjs from "dayjs";
import Paper from "@mui/material/Paper";
import {DataGrid, GridActionsCellItem} from "@mui/x-data-grid";
import {GET, POST} from "APIclient";
import {useEffect, useState} from "react";
import MDInput from "components/MDInput";
import {useMaterialUIController} from "context";
import {useLocation, useNavigate} from "react-router-dom";
import properties from "constants/ApplicationConstants";
import axios from "axios";
import {BASE_URL} from "APIclient";
import {formatDesignation} from "constants/ApplicationConstants";
import {formatDate} from "constants/ApplicationConstants";

export default function BonafideCertificate() {
  const empId = window.sessionStorage.getItem("empId");
  const theme = useTheme();
  const [controller] = useMaterialUIController();
  const {darkMode} = controller;
  const location = useLocation();
  const navigate = useNavigate();
  const [usersState] = useState(location.state);
  const [open, setOpen] = useState(false);
  const [snakColor, setSnakColor] = useState("");
  const [snakMessage, setSnakMessage] = useState("");
  const [details, setDetails] = useState({});
  const [data, setData] = useState([]);
  const [hrManager, setHrManager] = useState([]);
  const [formData, setFormData] = useState({
    reason: "",
    issuedBy: ""
  });
  const [errors, setErrors] = useState({
    reason: "",
    issuedBy: ""
  });
  const [isFormValid, setIsFormValid] = useState(false);

  const fetchUrl = `admin/employee/get-bonafide-certificate/${usersState}`;
  const viewUrl = `admin/get-salaries/${usersState}`;

  // Validations
  const validateField = (name, value) => {
    let tempErrors = {...errors};

    if (name === "reason") {
      if (!value || value.trim().length < 5) {
        tempErrors.reason = "Reason is required (min 5 characters)";
      } else if (/[^a-zA-Z\s]/.test(value)) {
        tempErrors.reason = "Reason should not contain numbers or special characters";
      } else {
        tempErrors.reason = "";
      }
    }

    if (name === "issuedBy") {
      if (!value) {
        tempErrors.issuedBy = "Please select the HR Manager";
      } else {
        tempErrors.issuedBy = "";
      }
    }

    return tempErrors;
  };

  const validateForm = () => {
    let tempErrors = {
      reason: "",
      issuedBy: ""
    };
    let isValid = true;

    if (!formData.reason || formData.reason.trim().length < 5) {
      tempErrors.reason = "Reason is required (min 5 characters)";
      isValid = false;
    }

    if (!formData.issuedBy) {
      tempErrors.issuedBy = "Please select the HR Manager";
      isValid = false;
    }

    setErrors(tempErrors);
    return isValid;
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await GET(fetchUrl);
        if (response?.data?.statusCode === 200) {
          setData(response.data.data);
        } else {
          // setSnakColor("error");
          // setSnakMessage(response?.data?.message || "Failed to fetch data");
          // setOpen(true);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setSnakColor("error");
        setSnakMessage("Error fetching data");
        setOpen(true);
      }
    };

    const view = async () => {
      try {
        const response = await GET(viewUrl);
        if (response?.data?.statusCode === 200) {
          const viewData = response.data.data;
          setDetails({
            ...viewData,
            designation: formatDesignation(viewData?.designation)
          });
        }
      } catch (error) {
        console.error("Error fetching employee details:", error);
      }
    };

    fetchData();
    view();
  }, [fetchUrl, viewUrl]);

  // Fetch HR managers
  useEffect(() => {
    const getUrl = `admin/hr-managers`;
    const getHrManager = async () => {
      try {
        const response = await GET(getUrl);
        if (response?.data?.statusCode === 200) {
          setHrManager(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching HR managers:", error);
      }
    };
    getHrManager();
  }, []);

  // Form validation check
  useEffect(() => {
    const isValid = formData.reason.trim().length >= 5 && !!formData.issuedBy;
    setIsFormValid(isValid);
  }, [formData]);

  // Handle form change
  const handleChange = event => {
    const {name, value} = event.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
    const updatedErrors = validateField(name, value);
    setErrors(updatedErrors);
  };

  // Handle form submission
  const handleSubmit = async () => {
    if (!validateForm()) return;

    const dt = {
      reason: formData.reason,
      issuedBy: parseInt(formData.issuedBy)
    };

    const url = `admin/employee/bonafide-certificate/${usersState}`;

    try {
      const response = await POST(url, dt);
      if (response?.data?.statusCode === 200) {
        setSnakColor("success");
        setSnakMessage("Bonafide Certificate added successfully");
        setOpen(true);
        const fetchResponse = await GET(fetchUrl);
        if (fetchResponse?.data?.statusCode === 200) {
          setData(fetchResponse.data.data);
        } else {
          setSnakColor("error");
          setSnakMessage(fetchResponse?.data?.message || "Failed to refresh data");
          setOpen(true);
        }
      } else {
        setSnakColor("error");
        setSnakMessage(response?.data?.message || "Failed to add Bonafide Certificate");
        setOpen(true);
      }
    } catch (error) {
      console.error("Error adding Bonafide Certificate:", error);
      setSnakColor("error");
      setSnakMessage("Error adding Bonafide Certificate");
      setOpen(true);
    }
  };

  const handlePrintAddressLetter = async row => {
    try {
      const url = `${BASE_URL}/admin/employee/downloadCertificate?type=bonafied_letter&search=${row.empBonCertificateId}`;

      const response = await axios.get(url, {
        headers: {
          Accept: "application/pdf",
          Authorization: `Bearer ${window.sessionStorage.getItem("jwtToken")}`
        },
        responseType: "blob",
        withCredentials: true
      });

      if (response.status !== 200) {
        throw new Error("Failed to fetch the address letter PDF");
      }

      const fileBlob = new Blob([response.data], {type: "application/pdf"});

      const fileUrl = URL.createObjectURL(fileBlob);

      const newWindow = window.open(fileUrl, "_blank");

      if (!newWindow) {
        alert("Please allow pop-ups to view the appointment letter.");
      }
    } catch (error) {
      console.error("Error fetching appointment letter:", error);
      alert("Error generating the appointment letter. Please try again.");
    }
  };

  // Handle snackbar close
  const handleClose = () => {
    setOpen(false);
  };

  // DataGrid columns
  const columns = [
    {field: "empBonCertificateId", headerName: "#", width: 30},
    {field: "issuedBy", headerName: "Issued By", width: 150},
    {field: "reason", headerName: "Reason", width: 150},
    {
      field: "issuedOn",
      headerName: "Issued On",
      width: 150,
      renderCell: params => formatDate(params.value) || "N/A"
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 80,
      renderCell: params => [
        <GridActionsCellItem
          key={`print-${params.row.empBonCertificateId}`}
          icon={
            <Tooltip title="Print Bonafide Certificate" arrow>
              <PrintIcon />
            </Tooltip>
          }
          label="Print"
          color="success"
          onClick={() => handlePrintAddressLetter(params.row)}
        />
      ]
    }
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox>
        <AppBar position="static">
          <MDBox pt={4} pb={3} px={0}>
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <Card>
                  <MDTypography
                    p={2}
                    variant="h6"
                    fontWeight="bold"
                    sx={{fontFamily: properties.fontFamily}}
                  >
                    Add Bonafide Certificate
                  </MDTypography>
                  <MDBox pt={0} alignItems="center">
                    <MDInput
                      sx={{m: 1, width: "20ch"}}
                      multiline
                      maxRows={4}
                      type="text"
                      name="reason"
                      value={formData.reason}
                      onChange={handleChange}
                      label={
                        <span>
                          Reason <span style={{color: properties.colors.Red}}>*</span>
                        </span>
                      }
                      variant="standard"
                      error={!!errors.reason}
                      helperText={errors.reason}
                    />
                  </MDBox>
                  <MDBox pt={2}>
                    <FormControl variant="standard" sx={{m: 1, width: "20ch"}}>
                      <InputLabel
                        id="issuedBy"
                        sx={{fontWeight: "bold", fontFamily: properties.fontFamily}}
                      >
                        Issued By <span style={{color: properties.colors.Red}}>*</span>
                      </InputLabel>
                      <Select
                        labelId="issuedBy"
                        id="issuedBy"
                        value={parseInt(formData.issuedBy) || ""}
                        name="issuedBy"
                        onChange={handleChange}
                        label="Issued By"
                        required
                        sx={{fontFamily: properties.fontFamily}}
                      >
                        <MenuItem value="">
                          <em>Select</em>
                        </MenuItem>
                        {hrManager.map(manager => (
                          <MenuItem key={manager.empId} value={manager.empId}>
                            {`${manager.firstName} ${manager.lastName}`}
                          </MenuItem>
                        ))}
                      </Select>
                      {errors.issuedBy && (
                        <span style={{color: "red", fontSize: "12px", marginLeft: "14px"}}>
                          {errors.issuedBy}
                        </span>
                      )}
                    </FormControl>
                  </MDBox>
                  <MDBox mt={3} mb={2} sx={{display: "flex", justifyContent: "flex-end"}}>
                    <MDBox sx={{display: "flex", gap: 1}}>
                      <MDButton
                        variant="gradient"
                        color="warning"
                        sx={{
                          marginRight: "10px",
                          width: "12ch",
                          fontFamily: properties.fontFamily
                        }}
                        onClick={() => navigate(-1)}
                      >
                        Back
                      </MDButton>
                      <MDButton
                        variant="gradient"
                        color="info"
                        sx={{
                          width: "12ch",
                          mr: 2,
                          background: properties.colors.bgcolorbluethem,
                          fontFamily: properties.fontFamily
                        }}
                        onClick={handleSubmit}
                        disabled={!isFormValid}
                      >
                        Add
                      </MDButton>
                    </MDBox>
                  </MDBox>
                </Card>
                <Snackbar
                  open={open}
                  anchorOrigin={{vertical: "top", horizontal: "right"}}
                  autoHideDuration={1200}
                  onClose={handleClose}
                >
                  <Alert
                    onClose={handleClose}
                    severity={snakColor === "success" ? "success" : "error"}
                    variant="filled"
                    sx={{width: "100%", fontFamily: properties.fontFamily}}
                  >
                    {snakMessage}
                  </Alert>
                </Snackbar>
              </Grid>
              <Grid item xs={8}>
                <Card>
                  <MDBox p={2}>
                    <MDTypography
                      variant="h6"
                      fontWeight="bold"
                      sx={{fontFamily: properties.fontFamily}}
                    >
                      Employee Details
                    </MDTypography>
                  </MDBox>
                  <MDBox pb={2} px={3}>
                    <MDBox
                      component="li"
                      display="flex"
                      justifyContent="space-between"
                      alignItems="flex-start"
                      bgColor={darkMode ? "transparent" : "grey-100"}
                      borderRadius="lg"
                      p={2}
                      mt={1}
                    >
                      <MDBox width="100%" display="flex" flexDirection="column">
                        <MDBox
                          display="grid"
                          gridTemplateColumns={{xs: "1fr", sm: "repeat(2, 1fr)"}}
                          gap={2}
                          mb={2}
                        >
                          <MDBox display="flex" alignItems="center">
                            <MDTypography
                              variant="caption"
                              color="text"
                              fontFamily={properties.fontFamily}
                              sx={{fontSize: "12px", fontWeight: "500", minWidth: "120px"}}
                            >
                              Employee ID:
                            </MDTypography>
                            <MDTypography
                              variant="caption"
                              fontFamily={properties.fontFamily}
                              sx={{fontSize: "12px", fontWeight: "600", minWidth: "120px"}}
                            >
                              {details.empId || "-"}
                            </MDTypography>
                          </MDBox>
                          <MDBox display="flex" alignItems="center">
                            <MDTypography
                              variant="caption"
                              color="text"
                              fontFamily={properties.fontFamily}
                              sx={{fontSize: "12px", fontWeight: "500", minWidth: "120px"}}
                            >
                              Username:
                            </MDTypography>
                            <MDTypography
                              variant="caption"
                              fontFamily={properties.fontFamily}
                              sx={{fontSize: "12px", fontWeight: "600", minWidth: "120px"}}
                            >
                              {details
                                ? `${details.firstName || ""} ${details.lastName || ""}`.trim()
                                : "-"}
                            </MDTypography>
                          </MDBox>
                          <MDBox display="flex" alignItems="center">
                            <MDTypography
                              variant="caption"
                              color="text"
                              fontFamily={properties.fontFamily}
                              sx={{fontSize: "12px", fontWeight: "500", minWidth: "120px"}}
                            >
                              Joining Date:
                            </MDTypography>
                            <MDTypography
                              variant="caption"
                              fontFamily={properties.fontFamily}
                              sx={{fontSize: "12px", fontWeight: "600", minWidth: "120px"}}
                            >
                              {details.joinDate ? formatDate(details.joinDate) : "-"}
                            </MDTypography>
                          </MDBox>
                          <MDBox display="flex" alignItems="center">
                            <MDTypography
                              variant="caption"
                              color="text"
                              fontFamily={properties.fontFamily}
                              sx={{fontSize: "12px", fontWeight: "500", minWidth: "120px"}}
                            >
                              Designation:
                            </MDTypography>
                            <MDTypography
                              variant="caption"
                              fontFamily={properties.fontFamily}
                              sx={{fontSize: "12px", fontWeight: "600", minWidth: "120px"}}
                            >
                              {details.designation || "-"}
                            </MDTypography>
                          </MDBox>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                    <MDTypography
                      variant="h6"
                      fontWeight="bold"
                      pt={2}
                      pb={2}
                      sx={{fontFamily: properties.fontFamily}}
                    >
                      Bonafide Certificate Details
                    </MDTypography>
                    <Paper sx={{width: "100%", overflow: "auto"}}>
                      <DataGrid
                        rows={data}
                        columns={columns}
                        getRowId={row => row.empBonCertificateId || 0}
                        size="small"
                        aria-label="Bonafide Certificate Table"
                        pagination={false}
                        hideFooter={data.length <= 20}
                        hideFooterPagination
                        sx={{
                          fontFamily: properties.fontFamily,
                          fontSize: "14px",
                          "& .MuiDataGrid-columnHeaders": {
                            position: "sticky",
                            top: 0,
                            backgroundColor: "white",
                            zIndex: 1000
                          },
                          "& .MuiDataGrid-virtualScroller": {
                            overflow: "auto"
                          },
                          "& .MuiDataGrid-root": {
                            height: "auto",
                            maxHeight: "600px"
                          }
                        }}
                      />
                    </Paper>
                  </MDBox>
                </Card>
              </Grid>
            </Grid>
          </MDBox>
        </AppBar>
      </MDBox>
    </DashboardLayout>
  );
}
